import React, { useEffect } from "react";
import styles from "./slideshow.module.css";
import { useSelector, useDispatch } from "react-redux";
import { getPortal } from "../../services/selectors";
import news_image_default from "../../images/news_image_default.png";
import { END_LOADING, START_LOADING } from "../../services/actions/loading_actions";
import { INCREMENT_SLIDE, DECREMENT_SLIDE } from "../../services/actions/portal_actions";


const Slideshow = () => {

  const { images, index } = useSelector(getPortal);
  // const [currIndex, setCurrIndex] = useState(index);
  const dispatch = useDispatch();

  const handleDecrement = () => {
    // if (currIndex === 0) { setCurrIndex(images.length - 1); }
    // else { setCurrIndex(currIndex - 1); }
    dispatch({ type: START_LOADING });
    dispatch({ type: DECREMENT_SLIDE });
  }
  const handleIncrement = () => {
    // if (currIndex === images.length - 1) { setCurrIndex(0); }
    // else { setCurrIndex(currIndex + 1); }
    dispatch({ type: START_LOADING });
    dispatch({ type: INCREMENT_SLIDE });
  }

  const defaultImageHandler = (e) => {
    e.target.src = news_image_default;
  }

  const handleLoad = () => {
    dispatch({ type: END_LOADING });
  }

  useEffect(() => {
    dispatch({ type: START_LOADING });
    // eslint-disable-next-line
  },[]);

  return (
    <div className={styles.container}>
      {images.length > 1 &&
        <button
          className={styles.buttonLeft}
          onClick={handleDecrement}
        />
      }
      <img
        className={styles.img}
        // src={images[currIndex].image}
        src={images[index].image}
        // alt={images[currIndex].name}
        alt={images[index].name}
        onError={defaultImageHandler}
        onLoad={handleLoad}
      />
      {images.length > 1 &&
        <button
          className={styles.buttonRight}
          onClick={handleIncrement}
        />
      }
      <p className={styles.text}>
        {/* {images.length > 1 ? `(${currIndex + 1}/${images.length})` : ''}&nbsp;
        {images[currIndex].name} */}
        {images.length > 1 ? `(${index + 1}/${images.length})` : ''}&nbsp;
        {images[index].name}
      </p>
    </div>
  )
};

export default Slideshow;
